import { render, staticRenderFns } from "./ques-rate.vue?vue&type=template&id=e2563f4c&scoped=true"
import script from "./ques-rate.vue?vue&type=script&lang=js"
export * from "./ques-rate.vue?vue&type=script&lang=js"
import style0 from "./ques-rate.vue?vue&type=style&index=0&id=e2563f4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2563f4c",
  null
  
)

export default component.exports